var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 38",
    d: "M18.7894 6.63159H15.5214C14.9129 6.63159 14.457 7.17408 14.4549 7.78263C14.4454 10.614 12.5297 11.0526 11.0526 11.0526H8.73682C8.18453 11.0526 7.73682 11.5004 7.73682 12.0526V14.3684C7.73682 16.1369 9.2105 16.579 9.94734 16.579H16.1647C16.4299 16.579 16.6843 16.6843 16.8718 16.8719L19.2929 19.2929C19.9228 19.9229 21 19.4767 21 18.5858V8.84212C21 7.0737 19.5263 6.63159 18.7894 6.63159Z",
    fill: "#CFD6DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2632 7.73684C13.2632 8.32311 13.0303 8.88537 12.6157 9.29992C12.2012 9.71447 11.6389 9.94737 11.0526 9.94737H4.83527C4.57005 9.94737 4.3157 10.0527 4.12816 10.2403L1.70711 12.6613C1.07714 13.2913 0 12.8451 0 11.9542V2.21053C0 0.994737 0.994737 0 2.21053 0H11.0526C11.6389 0 12.2012 0.232894 12.6157 0.647448C13.0303 1.062 13.2632 1.62426 13.2632 2.21053V7.73684Z",
    fill: "#CFD6DB"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line 5",
    d: "M3 3H9",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 6",
    d: "M3 6H7",
    stroke: "white",
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon_chat.3c361070e936cd59c404b216d1cb5ba7.svg";
export { ForwardRef as ReactComponent };